
import { CatHeading } from '@blocks-react/components/Heading';
import { SerialSugestionProps } from '../types';

export const MyEquipmentSerialPrefix = ({
  prefixLabel,
  suggestions
}:SerialSugestionProps) => {
    return (<CatHeading variant="footnote">
                <span className="me-1">{prefixLabel}</span>
                <span className="fw-bold">{suggestions}</span>
            </CatHeading>
);
};
